import moment from "moment";
import i18next from "i18next";

/**
 *
 * @returns {bool}
 */

export const getMinutesSinceMidnight = () => {
    const currentTime = moment();
    const startOfToday = currentTime.clone().startOf("day");
    return currentTime.diff(startOfToday, "minutes");
};

/**
 * @param {string} date
 * @returns {bool}
 */
export const isTommorow = (date) => {
    const tommorowOfInput = moment(date);
    const tommorow = moment().add(1, "day");
    return tommorow.isSame(tommorowOfInput, "d");
};

/**
 * @param {string} date
 * @returns {bool}
 */
export const isToday = (date) => {
    const todayOfInput = moment(date);
    const tommorow = moment();
    return tommorow.isSame(todayOfInput, "d");
};

/**
 * @param {string} date
 * @returns {string}
 */
export const getLocalisedDayOfWeek = (date) => {
    if (isToday(date)) {
        return i18next.t("days.today");
    }

    if (isTommorow(date)) {
        return i18next.t("days.tomorrow");
    }

    const dayOfWeek = moment(date).format("dddd").toLowerCase();
    return i18next.t(`days.${dayOfWeek}`);
};

export const readableDate = (date) => moment(date).format("D.M.YYYY");

/**
 * UNITS:
 * _________________
 * years	    y   |
 * quarters	    Q   |
 * months	    M   |
 * weeks	    w   |
 * days	        d   |
 * hours	    h   |
 * minutes	    m   |
 * seconds	    s   |
 * milliseconds	ms  |
 * _________________
 */
export const addToDate = ({ date = new Date(), value = 0, unit = "m" }) =>
    moment(date).add(value, unit);
export const subsFromDate = ({ date = new Date(), value = 0, unit = "m" }) =>
    moment(date).subtract(value, unit);
